<p>share-redirect works!</p>
